import React, { useState, useEffect } from 'react';
import { Color } from '../../const/Const';
import { Dropdown } from 'antd';
import { Persona, PersonaSize } from '@fluentui/react';
import { useNavigate } from 'react-router-dom';

const MenuPopoverEmp = (props) => {

    const navigate = useNavigate();
    const [items, setItems] = useState([]);

    useEffect(() => {
        let tItems = [];

        if (props?.data?.length > 0) {
            tItems = props.data.map((r, index) => {
                let vBorderBottom = {};
                if (index + 1 !== props.data.length) {
                    vBorderBottom = { borderBottom: '0.5px solid #DEDEDE' };
                }
                return {
                    key: r.key,
                    label: (
                        <div style={{ ...vBorderBottom }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div>
                                    <Persona hidePersonaDetails text={r.text} size={PersonaSize.size32} />
                                </div>
                                <div style={{ marginLeft: 8 }}>
                                    <div style={{ fontSize: 14 }}>
                                        {r.text}
                                    </div>
                                    <div style={{ fontSize: 12, color: Color.grayText }}>
                                        {r.secondarytext}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ),
                    onClick: () => navigate('/hrsuite/employee/' + r.key)
                };
            });
        }
        setItems(tItems);
    }, [props.data]);

    return (
        <span>
            {items?.length > 0 && (
                <Dropdown menu={{ items }} trigger={['click']}>
                    <span style={{ fontSize: 14, color: Color.blue }}>({items?.length})</span>
                </Dropdown>
            )}
        </span>
    );
}

export default MenuPopoverEmp;
